import {
  AppContext,
  isAuthorised,
  ALL_MODULES,
  getTranslatedText,
  isFeatureAuthorisedInPlan,
  getLeftNavModuleList,
  getLeftNavCreateList,
  GlobalTimerSection,
  TAB_PAGES,
  useActivityTracker,
  useCheckFeatureGating,
  isProductAuthorised
} from '@nile/components';
import { injectIntl, useIntl } from 'react-intl';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import { Module } from '@nile/mangifera/src/Pebbles/AppHomePage';
import { getTabTemplate } from '@nile/mangifera/src/Pebbles/TabManager';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FormattedMessage } from 'react-intl';
import { KB_ROUTE } from '@nile/rmm/src/modules/knowledge-base';
import {
  CREATE_ARTICLE_ID,
  KB_ARTICLE_MODULE
} from '@nile/rmm/src/modules/knowledge-base/helper/constants';

function MenuPage(props) {
  const flags = useFlags();
  const intl = useIntl();
  const appContext = useContext(AppContext);
  const homeContext = useContext(HomeContext);
  const { user, currentProduct } = appContext;
  const showNetworkView = useCheckFeatureGating('network-monitoring-system');
  const isNewContracts = useCheckFeatureGating('CONTRACT_V3')?.enabled;
  // Module Menu Obj

  const moduleMenuObj = getLeftNavModuleList();

  // Create Menu Obj
  const createMenuObj = getLeftNavCreateList();

  const reference = user?.role?.roleFeatureList || [];

  const checkForProduct = (settingsProduct) => {
    if (
      settingsProduct &&
      !isProductAuthorised(currentProduct, settingsProduct)
    ) {
      return true;
    }
    return false;
  };
  // Authorised list create section

  const getAuthorisedList = (list, menuType) => {
    return list.filter((el) => {
      if (checkForProduct(el.productToCheck)) {
        return false;
      }
      if (el?.featureGateName) {
        if (isFeatureAuthorisedInPlan(el?.featureGateName)) {
          const checkAuthorisation = `${el?.authorisation}.${
            el.operation ? el.operation : menuType === 'create' ? 'add' : 'view'
          }`;
          let isFeatureAuthorised = false;
          if (el?.authorisation) {
            isFeatureAuthorised = el.ldFlag
              ? isAuthorised(reference, checkAuthorisation) && flags[el.ldFlag]
              : isAuthorised(reference, checkAuthorisation);
            return isFeatureAuthorised;
          }
          if (!el?.authorisation) {
            return true;
          }

          return isFeatureAuthorised;
        }
      } else {
        const checkAuthorisation = `${el?.authorisation}.${
          el.operation ? el.operation : menuType === 'create' ? 'add' : 'view'
        }`;
        let isFeatureAuthorised = false;
        if (el?.authorisation) {
          isFeatureAuthorised = el.ldFlag
            ? isAuthorised(reference, checkAuthorisation) && flags[el.ldFlag]
            : isAuthorised(reference, checkAuthorisation);
          return isFeatureAuthorised;
        }
        if (!el?.authorisation || !el.featureGateName) {
          return true;
        }

        return isFeatureAuthorised;
      }
    });
  };

  const RenderModule = ({ listName, menuType }) => {
    let listData = listName['data'];
    let listHeading = listName['categoryHeading'];
    let categoryFlag = listName?.flags;
    const authorisationList = getAuthorisedList(listData, menuType);
    return (categoryFlag ? (
      flags[categoryFlag] && authorisationList?.length > 0
    ) : (
      authorisationList?.length > 0
    )) ? (
      <div>
        <div className="sops-menu-head">
          <FormattedMessage id={listHeading} />
        </div>
        {authorisationList.map((el, i) => {
          return (
            <Module
              module={el}
              index={i}
              onClick={handleCreation.bind(this, el)}
            />
          );
        })}
      </div>
    ) : (
      <></>
    );
  };

  const handleCreation = (mod) => {
    const currentAppState = homeContext?.userAppState || { appState: [] };
    const updatedAppState = cloneDeep(currentAppState.appState);
    let tab = null;
    let tabIdx = null;
    if (props?.menuName === 'modules') {
      switch (mod.name) {
        case 'CLIENTS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/clientViews/3001/client-list'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'ORGANIZATION':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'it-insight');
          tab = {
            id: 'it-insight',
            content: getTabTemplate({ module: 'IT_INSIGHT' }),
            accessibilityLabel: 'Org tab',
            module: 'IT_INSIGHT',
            state: {},
            data: {},
            url: '/itsm/insights/company'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            tab.state = {
              selectDefault: true
            };
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'SITE':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'it-insight');
          tab = {
            id: 'it-insight',
            content: getTabTemplate({ module: 'IT_INSIGHT' }),
            accessibilityLabel: 'Org tab',
            module: 'IT_INSIGHT',
            state: {},
            data: {},
            url: '/itsm/insights/site'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            tab.state = {
              selectDefault: true
            };
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'DEPARTMENT':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'it-insight');
          tab = {
            id: 'it-insight',
            content: getTabTemplate({ module: 'IT_INSIGHT' }),
            accessibilityLabel: 'Org tab',
            module: 'IT_INSIGHT',
            state: {},
            data: {
              origin: 'departmentMenu'
            },
            url: '/itsm/insights/department'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            tab.state = {
              selectDefault: true
            };
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'USERS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'it-insight');
          tab = {
            id: 'it-insight',
            content: getTabTemplate({ module: 'IT_INSIGHT' }),
            accessibilityLabel: 'Org tab',
            module: 'IT_INSIGHT',
            state: {},
            data: {},
            url: '/itsm/insights/users'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            tab.state = {
              selectDefault: true
            };
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'ASSETS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
          tab = {
            id: 'rmm-home',
            content: getTabTemplate({ module: 'RMM_HOME' }),
            accessibilityLabel: 'Client tab',
            module: 'RMM_HOME',
            tabId: 3,
            state: {},
            data: {},
            url: '/rmm/asset-view/4001'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'NETWORK_MONITOR':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
          tab = {
            id: 'rmm-home',
            content: getTabTemplate({ module: 'RMM_HOME' }),
            accessibilityLabel: 'Client tab',
            module: 'RMM_HOME',
            tabId: 3,
            state: {},
            data: {},
            url: '/rmm/network-view/6001'
          };

          if (showNetworkView.upsell || flags.networkEndpointAsset) {
            useActivityTracker({
              event: 'Inproduct purchase - menu action - network monitoring'
            });
          }
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'KNOWLEDGE_BASE':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'itDocs');
          tab = {
            id: 'itDocs',
            content: getTabTemplate({ module: 'IT_DOCS' }),
            accessibilityLabel: 'Client tab',
            module: 'IT_DOCS',
            state: {},
            data: {},
            url: KB_ROUTE.ALL_ARTICLE_VIEW
          };
          if (tabIdx === -1) {
            useActivityTracker({
              event: 'KNOWLEDGE_BASE_MENU_CLICK'
            });
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'ITDOC':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'itDocs');
          tab = {
            id: 'itDocs',
            content: getTabTemplate({ module: 'IT_DOCS' }),
            accessibilityLabel: 'Client tab',
            module: 'IT_DOCS',
            state: {},
            data: {},
            url: '/rmm/itdoc/Password&&1001'
          };
          //This fix is added for backward compatibility when existing assets tab have
          //IT docs section opened and this will become obsolete after tabs are refreshed
          const dupTab = updatedAppState.findIndex((el) => el.url === tab.url);
          if (dupTab > -1) {
            updatedAppState[dupTab].url = '/rmm/patch/1001';
          }
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'PATCHES':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
          tab = {
            id: 'rmm-home',
            content: getTabTemplate({ module: 'RMM_HOME' }),
            accessibilityLabel: 'Client tab',
            module: 'RMM_HOME',
            tabId: 3,
            state: {},
            data: {},
            url: '/rmm/patch/1001'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'ALERTS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
          tab = {
            id: 'rmm-home',
            content: getTabTemplate({ module: 'RMM_HOME' }),
            accessibilityLabel: 'Client tab',
            module: 'RMM_HOME',
            tabId: 3,
            state: {},
            data: {},
            url: '/rmm/alert/1013'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'SCRIPTS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
          tab = {
            id: 'rmm-home',
            content: getTabTemplate({ module: 'RMM_HOME' }),
            accessibilityLabel: 'Client tab',
            module: 'RMM_HOME',
            tabId: 3,
            state: {},
            data: {},
            url: '/rmm/script/1011'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'COMMUNITY_SCRIPTS':
          tabIdx = updatedAppState.findIndex(
            (el) => el.id === 'script-library'
          );
          tab = {
            id: 'script-library',
            content: getTabTemplate({ module: 'SCRIPTS_HOME' }),
            accessibilityLabel: 'Script library',
            module: 'SCRIPTS_HOME',
            tabId: 'script-library-tab',
            state: {},
            data: {},
            url: '/rmm/scripts-library/scripts/1011'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'REPORTS':
          tabIdx = updatedAppState.findIndex(
            (el) => el.id === 'reports-charts'
          );
          tab = {
            id: 'reports-charts',
            content: getTabTemplate({
              module: 'REPORTS_CHARTS_HOME',
              data: {
                title: getTranslatedText(intl, 'reports.dashboard.title')
              }
            }),
            accessibilityLabel: 'Client tab',
            module: 'REPORTS_CHARTS_HOME',
            tabId: 11,
            state: {},
            data: {},
            url: '/report/1/view'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'CHARTS':
          tabIdx = updatedAppState.findIndex(
            (el) => el.id === 'reports-charts'
          );
          tab = {
            id: 'reports-charts',
            content: getTabTemplate({
              module: 'REPORTS_CHARTS_HOME',
              data: {
                title: getTranslatedText(intl, 'reports.dashboard.title')
              }
            }),
            accessibilityLabel: 'Client tab',
            module: 'REPORTS_CHARTS_HOME',
            tabId: 11,
            state: {},
            data: {},
            url: '/charts/2001/All Charts'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'PROJECTS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
          tab = {
            id: 'workspace',
            content: getTabTemplate({ module: 'WORKSPACE' }),
            accessibilityLabel: 'My workspace',
            module: 'WORKSPACE',
            tabId: 6,
            state: {},
            data: {},
            url: '/project/6/project-list'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'TASKS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
          tab = {
            id: 'workspace',
            content: getTabTemplate({ module: 'WORKSPACE' }),
            accessibilityLabel: 'My workspace',
            module: 'WORKSPACE',
            tabId: 8,
            state: {},
            data: {},
            url: '/tasks/3/task-list'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'UNKNOWN_EMAILS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/mailBoxViews/5006/Unknown Emails'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'ALL CONTRACTS':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/contractViews/1/All contracts'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'CONTRACT TEMPLATE':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/contractViews/1/Contract templates'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'QUOTES':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/quoteViews/24/All Quotes'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'INVOICE':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/invoiceViews/32/invoice-list'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'INVOICE AUDIT':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/invoiceAuditViews/101/Invoice audit'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'SALES_INBOX':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
          tab = {
            id: 'client',
            content: getTabTemplate({ module: 'ALL_CLIENTS' }),
            accessibilityLabel: 'Client tab',
            module: 'ALL_CLIENTS',
            tabId: 2,
            state: {},
            data: {},
            url: '/mailBoxViews/5004/All Conversations'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'TIMESHEET':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'timesheet');
          tab = {
            id: 'timesheet',
            content: getTabTemplate({ module: 'TIMESHEET' }),
            accessibilityLabel: 'Timesheet',
            module: 'TIMESHEET',
            tabId: 8,
            state: {},
            data: {},
            url: '/timesheet'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'SCHEDULING':
          tabIdx = updatedAppState.findIndex((el) => el.id === 'scheduling');
          tab = {
            id: 'scheduling',
            content: getTabTemplate({ module: 'SCHEDULING' }),
            accessibilityLabel: 'Scheduling',
            module: 'SCHEDULING',
            tabId: 'scheduling',
            state: {},
            data: {},
            url: '/scheduling'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'WORKSPACE':
        default:
          tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
          tab = {
            id: 'workspace',
            content: getTabTemplate({ module: 'WORKSPACE' }),
            accessibilityLabel: 'My workspace',
            module: 'WORKSPACE',
            tabId: 8,
            state: {},
            data: {},
            url: '/ticket/1/ticket-list'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
      }
    }

    if (props?.menuName === 'create') {
      switch (mod.name) {
        case 'TICKET':
          tab = updatedAppState.find((el) => el.id === 'new-tab');
          if (!tab) {
            tab = {
              id: 'new-tab',
              content: getTabTemplate({ module: 'NEW' }),
              module: 'NEW',
              tabId: 'new-tab',
              state: {},
              data: {},
              url: '/ticket/aWqgT35s/new'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'CLIENTS':
          tab = updatedAppState.find((el) => el.id === 'create-client');
          if (!tab) {
            tab = {
              id: 'create-client',
              content: getTabTemplate({ module: 'CLIENT_CREATION' }),
              module: 'CLIENT_CREATION',
              tabId: 'create-client',
              state: {},
              data: {},
              url: '/client/B604yRELWW/new'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'PROJECTS':
          tab = updatedAppState.find((el) => el.id === 'create-project');
          if (!tab) {
            tab = {
              id: 'create-project',
              content: getTabTemplate({
                module: ALL_MODULES.projectCreation,
                data: { title: 'New Project' }
              }),
              module: ALL_MODULES.projectCreation,
              tabId: 'create-project',
              state: {},
              data: {},
              url: '/project/B604yRELWW/new'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'NEW_CONTRACT_TEMPLATE':
          tab = updatedAppState.find((el) => el.id === 'new-contract-template');
          if (!tab) {
            tab = {
              id: 'new-contract-template',
              content: getTabTemplate({ module: 'NEW_CONTRACT_TEMPLATE' }),
              module: 'NEW_CONTRACT_TEMPLATE',
              tabId: 'new-contract-template',
              state: {},
              data: {},
              url: '/contracttemplate/H2Es51Am/new'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'REPORTS':
          tab = updatedAppState.find((el) => el.id === 'reports-charts');
          if (!tab) {
            tab = {
              id: 'reports-charts',
              content: getTabTemplate({
                module: 'REPORTS_CHARTS_HOME',
                data: { title: 'New Dashboard' }
              }),
              module: 'REPORTS_CHARTS_HOME',
              tabId: 11,
              state: { activeView: 'custom', source: 'overlay' },
              data: {},
              url: '/report/B604yRELWW/new'
            };
            updatedAppState.push(tab);
          } else {
            const tabIdx = updatedAppState.findIndex(
              (el) => el.id === 'reports-charts'
            );
            tab = {
              id: 'reports-charts',
              content: getTabTemplate({
                module: 'REPORTS_CHARTS_HOME',
                data: { title: 'Reports & Charts' }
              }),
              module: 'REPORTS_CHARTS_HOME',
              tabId: 11,
              state: { activeView: 'custom', source: 'overlay' },
              data: {},
              url: '/report/B604yRELWW/new'
            };
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'CHARTS':
          const tabIdx = updatedAppState.findIndex(
            (el) => el.id === 'reports-charts'
          );
          tab = {
            id: 'reports-charts',
            content: getTabTemplate({
              module: 'REPORTS_CHARTS_HOME',
              data: {
                title: getTranslatedText(intl, 'reports.dashboard.title')
              }
            }),
            accessibilityLabel: 'Client tab',
            module: 'REPORTS_CHARTS_HOME',
            tabId: 11,
            state: {
              openModal: true,
              activeView: 'custom'
            },
            data: {},
            url: '/charts/2001/All Charts'
          };
          if (tabIdx === -1) {
            updatedAppState.push(tab);
          } else {
            updatedAppState[tabIdx] = tab;
          }
          break;
        case 'SCRIPTS':
          tab = updatedAppState.find((el) => el.id === 'create-script');
          if (!tab) {
            tab = {
              id: 'create-script',
              content: getTabTemplate({
                module: 'CREATE_SCRIPT',
                data: { title: 'New Script' }
              }),
              module: 'CREATE_SCRIPT',
              tabId: 'create-script',
              state: {},
              data: {},
              url: '/rmm/script/TxMcMMvvx/create'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'PROBE':
          tab = updatedAppState.find((el) => el.id === 'create-probe');
          if (!tab) {
            tab = {
              id: 'create-probe',
              content: getTabTemplate({
                module: 'CREATE_PROBE',
                data: { title: 'New probe' }
              }),
              module: 'CREATE_PROBE',
              tabId: 'create-probe',
              state: {},
              data: {},
              url: '/rmm/probe/TxMcMMvvx/create'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'CREDENTIALS':
          tab = updatedAppState.find((el) => el.id === 'create-credential');
          if (!tab) {
            tab = {
              id: 'create-credential',
              content: getTabTemplate({
                module: 'CREATE_CREDENTIALS',
                data: { title: 'Create credential' }
              }),
              module: 'CREATE_CREDENTIALS',
              tabId: 'create-credential',
              state: {},
              data: {},
              url: '/rmm/credential/TxMcMMvvx/create'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'ITDOC':
          tab = updatedAppState.find(
            (el) => el.id === 'create-non-monitored-asset'
          );
          if (!tab) {
            tab = {
              id: 'create-non-monitored-asset',
              content: getTabTemplate({
                module: 'CREATE_NON_MONITORED_ASSET_FORM',
                data: { title: 'Create IT Documentation' }
              }),
              module: 'CREATE_NON_MONITORED_ASSET_FORM',
              tabId: 'create-non-monitored-asset',
              state: {},
              data: {},
              url: '/non-monitored-asset-form/create'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'KNOWLEDGE_BASE':
          tab = updatedAppState.find(
            (el) => el.id === `kb-${CREATE_ARTICLE_ID}`
          );
          if (!tab) {
            tab = {
              module: KB_ARTICLE_MODULE,
              id: `kb-${CREATE_ARTICLE_ID}`,
              url: `/kb/article/${CREATE_ARTICLE_ID}/create`,
              data: {
                id: CREATE_ARTICLE_ID,
                type: 'create'
              }
            };
            updatedAppState.push(tab);
          }
          break;
        case 'MAIL_BOX':
          tab = updatedAppState.find((el) => el.id === 'create-email');
          if (!tab) {
            tab = {
              id: 'create-email',
              content: getTabTemplate({
                module: TAB_PAGES.mailbox,
                data: { title: 'New email' }
              }),
              module: TAB_PAGES.mailbox,
              tabId: 'create-email',
              state: {},
              data: {},
              url: '/mail/create'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'NEW_INVOICE':
          tab = updatedAppState.find((el) => el.id === 'create-invoice');
          if (!tab) {
            tab = {
              id: 'create-invoice',
              content: getTabTemplate({
                module: TAB_PAGES.newInvoice,
                data: { title: 'New invoice' }
              }),
              module: TAB_PAGES.newInvoice,
              tabId: 'create-invoice',
              state: {},
              data: {},
              url: '/invoice/create'
            };
            updatedAppState.push(tab);
          }
          break;
        case 'NEW_QUOTE':
          tab = updatedAppState.find((el) => el.id === 'create-quote');
          if (!tab) {
            tab = {
              id: 'create-quote',
              content: getTabTemplate({
                module: TAB_PAGES.newQuote,
                data: {
                  title: getTranslatedText(intl, 'app.create.quote.tabTitle')
                }
              }),
              module: TAB_PAGES.newQuote,
              tabId: 'create-quote',
              state: {},
              data: {},
              url: '/quote/create'
            };
            updatedAppState.push(tab);
          }
          break;
        default:
          break;
      }
    }

    homeContext.updateUserAppState(
      {
        ...currentAppState,
        appState: updatedAppState,
        activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
      },
      () => {
        homeContext.switchTabFocus(tab, updatedAppState);
      }
    );
    props.handleClose();
  };

  return (
    <>
      {props.menuName === 'modules' && (
        <>
          {Object.keys(moduleMenuObj).map((list) => {
            const navProduct = moduleMenuObj[list].productToCheck;
            if (checkForProduct(navProduct)) {
              return false;
            }
            return (
              <RenderModule listName={moduleMenuObj[list]} menuType="module" />
            );
          })}
        </>
      )}
      {props.menuName === 'create' && (
        <>
          {Object.keys(createMenuObj).map((list) => {
            const navProduct = createMenuObj[list].productToCheck;
            if (checkForProduct(navProduct)) {
              return false;
            }
            return (
              <RenderModule listName={createMenuObj[list]} menuType="create" />
            );
          })}
        </>
      )}
    </>
  );
}
export default injectIntl(withRouter(withLDConsumer()(MenuPage)));
